module.exports = __webpack_public_path__ + "8b4501a8b30c7ad9b1fe1465a9f18435.gif";